import { Banknote, CreditCard, Landmark, NotebookPen, QrCode } from 'lucide-react'

import { PosModel } from '@/types'

/** The POS payment methods (POS.md D22). Credit needs a customer and is checked against their limit (§15.4). */
export const PAYMENT_METHODS: { id: PosModel.PaymentMethod; label: string; icon: typeof Banknote; key: string }[] = [
  { id: 'cash', label: 'Cash', icon: Banknote, key: '1' },
  { id: 'card', label: 'Card', icon: CreditCard, key: '2' },
  { id: 'bank', label: 'Bank', icon: Landmark, key: '3' },
  { id: 'qr', label: 'QR', icon: QrCode, key: '4' },
  { id: 'credit', label: 'Credit', icon: NotebookPen, key: '5' },
]
